import ParticipantTable from "./participantTable.container";

export default ParticipantTable;
